/** * 功能: 个人信息列表显示，个人的数据新增、修改，删除数据，可以关联厂牌数据 */

<template lang="pug">
  .staff-container
    //- el-col(:span="20")
    el-form(:inline="true" :model="findStaff" :size="GLOBAL.SIZE_OF_INPUTBOX")
      el-form-item(label="搜索")
        el-input.search(placeholder='请输入名字查询数据' @change="searchStaff" v-model='findStaff.fullSearch' suffix-icon="el-icon-search" clearable :size="GLOBAL.SIZE_OF_INPUTBOX")
    el-table(:data="staffData" stripe style="width: 100%" @sort-change='staffSortChange' v-loading="loading" width="100%^")
      el-table-column(prop="name" label="名字" sortable="name" width="200px")
      //- el-table-column(prop="gender" label="性别" sortable="gender" width="")
      //-   template(slot-scope="scope")
      //-     span {{genderEnum[scope.row.gender]}}
      el-table-column(prop="role" label="权限" width= "")
        template(slot-scope="scope")
          el-cascader.auth-select(v-model="scope.row.role" :options="options" :props="props" @change='authChange(scope.row)' tag-type="success")
      //- el-table-column(prop="isValid" label="是否有效" sortable="isValid" width= "")
      //-   template(slot-scope="scope")
      //-     el-button(:type="scope.row.isValid === true ? 'primary' : 'danger'" :size="GLOBAL.SIZE_OF_INPUTBOX" round @click="changeStaffValid(scope.row,scope.$index)") {{scope.row.isValid === true ? '生效中' : '失效中'}}
      //- el-table-column(label='操作' width='300' align="center")
      //-   template(slot-scope="scope")
      //-     el-button-group
      //-       el-button(title="编辑" round icon="el-icon-edit" size="mini" type="info"
      //-       @click="$router.push({ name: 'sizeProFrom', query: { id: scope.row._id } })")
    el-row(:gutter="10")
      el-col
          el-pagination(
              background
              @current-change="handleCurrentChange"
              :current-page.sync="findStaff.currentPage"
              layout="total,prev, pager, next, jumper"
              :page-size="findStaff.pageSize"
              :total="totalPage")
</template>

<script>
import Staff from '@/apis/staff'
import ENUM from '@/apis/enum'

// 管理员权限页面
export default {
  components: {},
  data () {
    return {
      findStaff: {
        fullSearch: '',
        currentPage: 1,
        pageSize: 15,
        // sortwhere: { order: 'descending', prop: 'role' }
        sortwhere: { order: '', prop: 'role' }
      },
      totalPage: 0,
      staffData: [],
      loading: false,
      genderEnum: {
        0: '保密',
        1: '男',
        2: '女'
      },
      props: { multiple: true }, // 级联选择器配置
      options: ENUM.AUTH_OPTIONS
    }
  },
  created () {
    this.getStaffPage()
  },
  methods: {
    // 个人列表 排序
    staffSortChange (column) {
      const { order, prop } = column
      this.findStaff.sortwhere = { order, prop }
      this.getStaffPage()
    },
    // 搜索
    searchStaff () {
      this.findStaff.currentPage = 1
      this.getStaffPage()
    },
    // 获取个人信息分页
    getStaffPage (pageNo) {
      this.loading = true
      Staff.getStaffPage(this.findStaff)
        .then((r) => {
          if (r.errCode !== 0) return this.$message({ type: 'warning', message: '' + r.msg })
          this.totalPage = r.data.count
          this.staffData = r.data.data
        })
        .catch((err) => {
          console.log('获取用户信息失败', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取个人分页
    handleCurrentChange (val) {
      this.findStaff.currentPage = val
      this.getStaffPage()
    },
    // 权限变更
    authChange (row) {
      const temp = JSON.parse(JSON.stringify(row))
      // temp.role = role
      this.loading = true
      Staff.updateStaff(temp)
        .then((res) => {
          if (res.errCode !== 0) return this.$message({ type: 'warning', message: '' + res.msg })
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          // row.role = role
        })
        .catch((err) => {
          console.log('updateerr', err)
        })
        .finally(() => {
          this.loading = false
        })
    }
    // 禁用账号
    // changeStaffValid (row) {
    //   let temp = JSON.parse(JSON.stringify(row))
    //   this.loading = true
    //   temp.isValid = !row.isValid
    //   Staff.updateStaff(temp).then(res => {
    //     if (res.errCode !== 0) return this.$message({ type: 'warning', message: '' + res.msg })
    //     this.$message({
    //       message: '更新成功',
    //       type: 'success'
    //     })
    //     row.isValid = !row.isValid
    //   }).catch(err => {
    //     console.log('updateerr', err)
    //   }).finally(() => {
    //     this.loading = false
    //   })
    // },
    // {Number} role
  }
}
</script>
<style lang="scss">
.staff-container .el-avatar > img {
  margin: 0 auto;
  width: 100%;
  height: 100%;
}
.el-button--text {
  padding: 0;
}

.el-tag--info span {
  color:#409EFF;
}
.auth-select {
  width: 100%;
}
</style>
